import { CommonModule } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CalibrationDetectorDTO } from 'src/app/model/calibration-detector-dto';
import { DiagnosisDataDTO } from 'src/app/model/diagnosis/diagnosis-data-dto';
import { RecordDTO } from 'src/app/model/diagnosis/record-dto';
import { LoadIndicatorService } from 'src/app/services/load-indicator.service';
import { NodeService } from 'src/app/services/node.service';

export type NodeDiagnosisInfoData = {
  node: number;
  anomaly: CalibrationDetectorDTO;
};
@Component({
  selector: 'app-node-diagnosis-info',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './node-diagnosis-info.component.html',
  styleUrl: './node-diagnosis-info.component.scss',
})
export class NodeDiagnosisInfoComponent implements OnInit {
  public diagnosisDataDTO?: DiagnosisDataDTO[];
  public selectedRecord?: RecordDTO;

  constructor(
    public nodeService: NodeService,
    public loadIndicatorService: LoadIndicatorService,
    public dialogRef: MatDialogRef<Component>,
    @Inject(MAT_DIALOG_DATA) public data: NodeDiagnosisInfoData,
  ) {}

  ngOnInit() {
    this.loadIndicatorService.show();
    this.nodeService
      .getNodeDiagnosisData(this.data.node, this.data.anomaly)
      .then((response) => {
        this.diagnosisDataDTO = response;
      })
      .finally(() => {
        this.loadIndicatorService.hide();
      });
  }

  selectRecord(record: RecordDTO): void {
    this.selectedRecord = record;
  }

  cancel() {
    this.dialogRef.close();
  }
}
